import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/api";
import { LogoMark } from "@/context/BrandingContext";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function Enroll() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [key, setKey] = useState(sp.get("key") || "");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (pw.length < 8) { setError("Wachtwoord moet minimaal 8 tekens zijn"); return; }
    if (pw !== pw2) { setError("Wachtwoorden komen niet overeen"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/enroll", { key: key.trim(), password: pw });
      setDone(true); toast.success(data.message || "Account geactiveerd");
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 p-6">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl" data-testid="enroll-page">
        <div className="mb-6 flex items-center gap-3"><LogoMark size={44} rounded="rounded-xl" /><div><div className="font-display text-lg font-bold text-slate-900">DispatchMe</div><div className="text-xs uppercase tracking-widest text-slate-400">Account activeren</div></div></div>
        {done ? (
          <div className="text-center" data-testid="enroll-done">
            <CheckCircle2 className="mx-auto mb-3 h-12 w-12 text-emerald-500" />
            <h2 className="font-display text-xl font-bold text-slate-900">Wachtwoord ingesteld</h2>
            <p className="mt-2 text-sm text-slate-500">Je account wacht nu op goedkeuring door de beheerder. Je krijgt bericht zodra je kunt inloggen.</p>
            <button onClick={() => navigate("/login")} className="mt-5 w-full rounded-xl bg-blue-600 py-2.5 text-sm font-semibold text-white hover:bg-blue-500">Naar inloggen</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-500">Voer je activatiesleutel in en kies een eigen wachtwoord.</p>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Activatiesleutel</label>
              <input data-testid="enroll-key" value={key} onChange={(e) => setKey(e.target.value)} required className="w-full rounded-xl border border-slate-200 px-3 py-2.5 font-mono text-sm uppercase tracking-widest outline-none focus:border-blue-500" placeholder="XXXXXXXXXX" />
            </div>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Wachtwoord</label>
              <input data-testid="enroll-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500" placeholder="Minimaal 8 tekens" />
            </div>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Herhaal wachtwoord</label>
              <input data-testid="enroll-password2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500" placeholder="••••••••" />
            </div>
            {error && <div data-testid="enroll-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</div>}
            <button data-testid="enroll-submit" type="submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 py-2.5 text-sm font-semibold text-white hover:bg-blue-500 disabled:opacity-60">{loading && <Loader2 className="h-4 w-4 animate-spin" />} Activeren</button>
          </form>
        )}
      </div>
    </div>
  );
}
